import { type Revision, RevisionType } from '../types';

/**
 * Returns the linear parent (the one used to walk up the history) of a revision.
 */
export function getRevisionLinearParent(revision: Revision): string | null {
    if (revision.parents.length === 0) {
        return null;
    }

    // For updates revisions on non default branch, use the parent that was the HEAD revision before the update.
    // For anything else use the ancestor.
    if (revision.type === RevisionType.Update) {
        return revision.parents[2];
    }

    // If the revision is the result of a 3-way merge, take the BASE.
    if (revision.parents.length === 3) {
        return revision.parents[1];
    }

    // Otherwise take the ancestor.
    return revision.parents[0];
}
